(() => {
  const normalize = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "");

  /* Valores de opcao de variante que LIGAM os campos de personalizacao.
     A loja usa "Customize" (opcao "Add Name & Number"); os demais ficam por
     compatibilidade com a versao PT antiga e com traducao de mercado.
     A comparacao e por igualdade exata, entao "Don't Customize" NAO liga. */
  const VALORES_ATIVA = [
    "customize",
    "customise",
    "personalizar",
    "personalizacao",
    "com personalizacao",
    "sim",
    "yes",
  ];

  const ativaPersonalizacao = (variant) => {
    const options = Array.isArray(variant?.options) ? variant.options : [];
    return options.some((opt) => VALORES_ATIVA.indexOf(normalize(opt)) !== -1);
  };

  function getInitialVariantFromSection(productInfoEl) {
    const script = productInfoEl?.querySelector('variant-selects script[data-selected-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Re-consulta o wrapper no DOM a cada uso: o Dawn substitui o HTML do
     product-info ao trocar de variante, e uma referencia guardada fica orfa. */
  function findWrapper(sectionId) {
    return document.querySelector(
      `[data-personalizacao-wrapper][data-section-id="${sectionId}"]`
    );
  }

  /* O motor da previa do nome e do numero (md-nameset.js) so vem quando a personalizacao
     liga de verdade. A URL vem do proprio HTML, no data-md-ns-src que o snippet escreve:
     asset_url e versionado por hash, entao nao da pra montar essa URL no JS.

     Por que sob demanda e nao um <script defer> no HTML: a maioria das visitas a uma PDP
     nao clica em "Customize". Poupar essas visitas de baixar o motor e uma requisicao e
     alguns KB e a diferenca entre um recurso que custa a todo mundo e um que custa a quem
     usa. Quem liga paga uma vez, e o arquivo fica no cache pro resto da navegacao. */
  function carregarPreview(wrapper) {
    if (!wrapper) return;
    /* Dois motores independentes, cada um com o seu atributo: a previa da camisa
       (md-nameset) e as abas de jogador (md-jogadores). Sao separados porque as
       coberturas nao coincidem - 378 produtos tem escalacao e nao tem previa medida, e
       juntar os dois faria essas PDPs baixarem um motor de desenho que nunca desenha. */
    ["data-md-ns-src", "data-md-jg-src"].forEach(function (attr) {
      const raiz = wrapper.querySelector("[" + attr + "]");
      if (!raiz) return;
      const src = raiz.getAttribute(attr);
      if (!src || document.querySelector('script[data-md-motor="' + src + '"]')) return;
      const s = document.createElement("script");
      s.src = src;
      s.defer = true;
      s.dataset.mdMotor = src;
      document.head.appendChild(s);
    });
  }

  /* O campo Numero aceitava qualquer tecla: o pattern="[0-9]*" esta no HTML, mas o form de
     compra tem novalidate, entao o navegador sabe que e invalido e nunca e perguntado.
     Medido em 11/09/2026: "-7" e "7B" desenhavam 7 na previa e gravavam o valor cru no
     pedido, e a planilha da fornecedora saia com a coluna Number dizendo "-7" ao lado de
     uma foto mostrando 7 - tres versoes da mesma camisa.

     A limpeza aqui e a MESMA que o textoNumero() do md-nameset.js ja fazia so pra desenhar;
     a diferenca e que agora ela volta pro campo, entao o que o cliente ve, o que o pedido
     grava e a foto que vai pra fabrica saem da mesma fonte.

     Mora NESTE arquivo e nao no motor da previa porque o md-nameset.js sai fora logo no
     inicio quando a camisa nao tem previa configurada, e o campo existe em toda camisa.
     O teto vem do proprio maxlength do campo, pra nunca brigar com uma camisa que aceite
     mais digitos. */
  function limitarNumero(campo) {
    if (!campo || campo.dataset.mdSoDigito === "1") return;
    campo.dataset.mdSoDigito = "1";
    campo.addEventListener("input", () => {
      const max = parseInt(campo.getAttribute("maxlength"), 10) || 2;
      const limpo = campo.value.replace(/\D/g, "").slice(0, max);
      if (campo.value !== limpo) campo.value = limpo;
    });
  }

  /* A TRAVA DO NOME E DO NUMERO (09/10/2026, pedido do Ivan): com "Customize" escolhido, a
     camisa so vai pro carrinho com os dois campos preenchidos.

     Ela existia no product-form.js do tema "Match Day [21/08]" e se perdeu quando o tema
     "Labor Day" foi publicado em 04/09/2026. De la ate 05/10 foram 33 pedidos com a variante
     Customize e o nome e o numero gravados em branco, e o cliente recebia a camisa lisa.

     Mora AQUI, e nao no product-form.js, porque ha DOIS caminhos ate o /cart/add: o submit
     do Dawn (product-form.js) e o interceptador dos patches (md-patches-carrinho), que escuta
     o submit em captura no document e manda o pedido sozinho quando ha patch marcado. Uma
     trava dentro do product-form.js deixaria passar a camisa com patch. Este listener fica na
     captura da WINDOW, que o navegador chama antes da captura do document e antes do listener
     do proprio form: um ponto so cobre os dois caminhos.

     O botao continua ativo de proposito (decisao do Ivan em 09/10/2026): apagado ele nao diz
     o motivo e parece esgotado, e o Dawn redesenha o estado do botao a cada troca de
     variante. A explicacao vem no clique, embaixo dos campos. */
  const AVISOS = {
    ambos: "Please enter a name and number.",
    nome: "Please enter a name.",
    numero: "Please enter a number.",
    jogador: "Please choose a player.",
  };

  /* O que falta e onde marcar. Na aba "Pick a player" os campos estao escondidos e quem
     preenche e o seletor, entao o pedido e escolher um jogador e a marca vai no seletor.
     Todo jogador da escalacao tem numero (1.422 de 1.422 em 09/10/2026): escolher um libera. */
  function avaliarPersonalizacao(wrapper) {
    const nome = wrapper.querySelector('[name="properties[Name]"]');
    const numero = wrapper.querySelector('[name="properties[Number]"]');
    if (!nome || !numero || nome.disabled) return null;
    const faltaNome = !nome.value.trim();
    const faltaNumero = !numero.value.trim();
    if (!faltaNome && !faltaNumero) return null;

    const seletor = wrapper.querySelector(".md-jg-seletor");
    if (seletor && seletor.parentNode && !seletor.parentNode.hidden) {
      return { texto: AVISOS.jogador, marcar: [seletor], foco: seletor };
    }
    const caixa = (campo) => campo.closest(".md-ps-caixa") || campo;
    const marcar = [];
    if (faltaNome) marcar.push(caixa(nome));
    if (faltaNumero) marcar.push(caixa(numero));
    return {
      texto: faltaNome && faltaNumero ? AVISOS.ambos : faltaNome ? AVISOS.nome : AVISOS.numero,
      marcar,
      foco: faltaNome ? nome : numero,
    };
  }

  function limparAviso(wrapper) {
    if (!wrapper) return;
    delete wrapper.dataset.mdAviso;
    wrapper.querySelectorAll(".md-ps-erro-campo").forEach((el) => el.classList.remove("md-ps-erro-campo"));
    const linha = wrapper.querySelector(".md-ps-erro");
    if (linha) linha.hidden = true;
  }

  /* Pinta o estado atual: no clique barrado e a cada digitacao enquanto o aviso esta na
     tela. O texto acompanha o que ainda falta e some quando nada falta. A linha nasce aqui,
     no primeiro clique barrado, logo abaixo dos campos: quem preenche certo nunca a recebe. */
  function pintarAviso(wrapper) {
    const falta = avaliarPersonalizacao(wrapper);
    if (!falta) {
      limparAviso(wrapper);
      return null;
    }
    wrapper.dataset.mdAviso = "1";
    wrapper.querySelectorAll(".md-ps-erro-campo").forEach((el) => el.classList.remove("md-ps-erro-campo"));
    falta.marcar.forEach((el) => el.classList.add("md-ps-erro-campo"));

    let linha = wrapper.querySelector(".md-ps-erro");
    if (!linha) {
      linha = document.createElement("p");
      linha.className = "md-ps-erro";
      linha.setAttribute("role", "alert");
      const campos = wrapper.querySelector(".md-ps-campos");
      if (campos) campos.insertAdjacentElement("afterend", linha);
      else wrapper.appendChild(linha);
    }
    if (linha.textContent !== falta.texto) linha.textContent = falta.texto;
    linha.hidden = false;
    return falta;
  }

  /* Os campos ficam FORA do <form> (entram nele pelo atributo form=), por isso a busca e
     pelo form.elements, que inclui quem aponta pro form por id. Campo desabilitado ("Don't
     Customize") e form que nao e de carrinho: a trava sai sem fazer nada. */
  function conferirAntesDoCarrinho(ev) {
    const form = ev.target;
    if (!form || form.tagName !== "FORM") return;
    if ((form.getAttribute("action") || "").indexOf("/cart/add") === -1) return;
    const nome = Array.from(form.elements || []).find((c) => c.name === "properties[Name]");
    const wrapper = nome && nome.closest("[data-personalizacao-wrapper]");
    if (!wrapper || wrapper.classList.contains("hidden")) return;

    const falta = pintarAviso(wrapper);
    if (!falta) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    const suave = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    falta.foco.scrollIntoView({ block: "center", behavior: suave ? "smooth" : "auto" });
    /* O cursor so vai pro campo no computador. Na tela de toque, focar o campo abre o
       teclado e focar o seletor abre a lista de jogadores sem o cliente pedir (ajuste do
       Ivan em 09/10/2026): ali a rolagem ate o aviso e o contorno vermelho bastam. */
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      falta.foco.focus({ preventScroll: true });
    }
  }

  window.addEventListener("submit", conferirAntesDoCarrinho, true);

  /* Enquanto o aviso esta na tela, cada digitacao, escolha de jogador ou troca de aba
     repinta. O frame seguinte da tempo ao md-jogadores de preencher os campos. */
  ["input", "change", "click"].forEach((tipo) => {
    document.addEventListener(tipo, (ev) => {
      const wrapper = ev.target && ev.target.closest && ev.target.closest("[data-personalizacao-wrapper]");
      if (!wrapper || wrapper.dataset.mdAviso !== "1") return;
      requestAnimationFrame(() => pintarAviso(wrapper));
    });
  });

  function togglePersonalizacao(wrapper, variant) {
    if (!wrapper) return;

    const campos = Array.from(wrapper.querySelectorAll("input, select, textarea"));

    if (ativaPersonalizacao(variant)) {
      wrapper.classList.remove("hidden");
      campos.forEach((campo) => {
        campo.disabled = false;
      });
      limitarNumero(wrapper.querySelector('[name="properties[Number]"]'));
      carregarPreview(wrapper);
    } else {
      wrapper.classList.add("hidden");
      limparAviso(wrapper);
      campos.forEach((campo) => {
        campo.value = "";
        campo.disabled = true;
      });
    }
  }

  function initPersonalizacaoForProductInfo(productInfoEl) {
    const sectionId = productInfoEl?.dataset?.section;
    if (!sectionId) return;
    if (productInfoEl.dataset.persoInit === "1") return;
    productInfoEl.dataset.persoInit = "1";

    /* Gatilho antecipado: quem encosta no seletor de variante esta a um passo de escolher
       "Customize". Buscar o motor aqui faz ele chegar antes do clique, entao o painel abre
       ja montado em vez de piscar vazio. `once` porque uma vez basta. */
    productInfoEl.addEventListener(
      "pointerdown",
      () => carregarPreview(findWrapper(sectionId)),
      { once: true, passive: true }
    );

    /* 1) estado inicial */
    togglePersonalizacao(findWrapper(sectionId), getInitialVariantFromSection(productInfoEl));

    /* 2) quando mudar variante (evento nativo do Dawn) */
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data;
        if (!data || data.sectionId !== sectionId) return;
        togglePersonalizacao(findWrapper(sectionId), data.variant);
        /* reforco no frame seguinte, caso o re-render do Dawn chegue depois do evento */
        requestAnimationFrame(() =>
          togglePersonalizacao(findWrapper(sectionId), data.variant)
        );
      });
    }
  }

  const initAll = () => {
    document.querySelectorAll("product-info").forEach(initPersonalizacaoForProductInfo);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
